import React from "react";
import { useNavigate } from "react-router-dom";

const OfferCard = ({ image, title, subtitle, productId }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/view-one-product/${productId}`);
  };
  
  return (
    <div className="relative overflow-hidden rounded-2xl cursor-pointer group shadow-[0_0_20px_rgba(0,0,0,0.15)] lg:shadow-[0_0_0px_rgba(0,0,0,0.0)]"
    onClick={handleCardClick}
    >
      <img
        src={image}
        alt={title}
        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
      />

      <div className="absolute inset-0 flex items-end p-4 sm:p-6">
        <div>
          <h3 className="text-white text-lg font-bold leading-tight">
            {title}
          </h3>
          <p className="text-white text-lg font-semibold">
           UP TO {subtitle}% OFF
          </p>
        </div>
      </div>
    </div>
  );
};

export default OfferCard;
